// URL para llamadas largas al backend (generación de imágenes con IA).
//
// Por qué existe: Firebase Hosting corta a los 60 s cualquier petición que
// reenvía a Cloud Functions, y gpt-image-1 tarda a menudo 52–69 s. El servidor
// terminaba la imagen pero el cliente recibía "Error del servidor" (1 de cada
// 3 previews en octubre de 2026). Llamando a la función directamente el límite
// es el de la propia función (300 s).
//
// En local (vite dev/preview) se sigue usando /api para no depender de CORS.
const FUNCTION_BASE = 'https://us-central1-funcomunion.cloudfunctions.net/api';
const HOSTS_PRODUCCION = ['funcomunion.es', 'www.funcomunion.es', 'funcomunion.web.app', 'funcomunion.firebaseapp.com', 'funkomunion.es', 'www.funkomunion.es', 'funcomunion.com'];

export function apiLargoUrl(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`;
  if (typeof window !== 'undefined' && HOSTS_PRODUCCION.includes(window.location.hostname)) {
    return `${FUNCTION_BASE}${p}`;
  }
  return `/api${p}`;
}
